import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ClassNames from 'classnames';
import Colors from 'utils/colors';
import Box from '@material-ui/core/Box';
import { hidePageSidebar } from 'utils/embedded';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  paddedTopInfoRoot: {
    paddingTop: 20,
  },
  videoRoot: {
    [theme.breakpoints.down('1200')]: {
      flexDirection: 'column',
    },
  },
  imageWrapper: {
    marginRight: 42,
    [theme.breakpoints.down('lg')]: {
      marginRight: 20,
    },
    [theme.breakpoints.down('sm')]: {
      margin: 0,
    },
  },
  bigWrapper: {
    [theme.breakpoints.down('1200')]: {
      marginRight: 0,
    },
  },
  link: {
    color: Colors.blue,
    fontFamily: 'PoppinsSemiBold',
    fontSize: 13,
  },

  ratingWrapper: {
    display: 'flex',
  },
  linkBtn: {
    textDecoration: 'none',
  },
  titleWithIcon: {
    display: 'flex',
  },
  descriptionWrapper: {
    '& span': {
      fontSize: 20,
      lineHeight: 1.5,
    },
  },
  infoRoot: {
    width: '100%',
  },
}));

function ResourceImageAndInfoLayout(props) {
  const { image, info, mobile, isBig, isShortViewHeader = false } = props;
  const classes = useStyles();
  const hideMobileNode = hidePageSidebar();

  return (
    <Box
      component="div"
      display="flex"
      flex="1 1 auto"
      className={ClassNames(classes.root, {
        [classes.videoRoot]: isBig,
      })}
    >
      {!isShortViewHeader && (
        <Box
          component="div"
          className={ClassNames(classes.imageWrapper, {
            [classes.bigWrapper]: isBig,
          })}
        >
          {image}
        </Box>
      )}

      {!hideMobileNode && mobile}

      <Box
        className={ClassNames(classes.root, classes.infoRoot, {
          [classes.paddedTopInfoRoot]: hideMobileNode,
        })}
      >
        {info}
      </Box>
    </Box>
  );
}

ResourceImageAndInfoLayout.propTypes = {
  image: PropTypes.node,
  info: PropTypes.node,
  mobile: PropTypes.node,
  isBig: PropTypes.bool,
};

export default ResourceImageAndInfoLayout;
